@if(!loading()) {
<div class="card shadow mt-3 m-auto">
  <img src="images/avm-logo-xl.png" class="card-img-top" alt="AVM Logo" />
  <div class="card-body text-center py-5">
    <button class="btn btn-danger btn-lg" (click)="navigateToLoginCidadao()">
      AUTENTICAR SOE
    </button>
  </div>
</div>
} @else {
<div class="row">
  <div
    class="spinner-border text-danger mx-auto my-5"
    style="width: 5rem; height: 5rem"
    role="status"
  >
    <span class="visually-hidden">Carregando...</span>
  </div>
</div>
<div class="row">
  <div class="text-danger mx-auto text-center fs-5">Aguarde, carregando...</div>
</div>
}
